module.exports = __webpack_public_path__ + "static/media/exclamation.aa294770.png";